// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"op-z","slideIn":"pp-z"};